import React from "react";
const SessionTokenContext = React.createContext("");

export default SessionTokenContext;
